<template>
    <div>
        <card-header :title="application.type" :icon="(application.type === 'application') ? 'fa-file-certificate' : 'fa-file-invoice'"/>

        <card-toolbar>
            <button @click="$openCard('edit-application', {applicationId: application.id}, card)"><i class="far fa-pencil"></i>Edit Details</button>
            <button @click="$openCard('new-application-component', {applicationId: application.id}, card)"><i class="far fa-file-plus"></i>New Component</button>
            <button @click="$openCard('import-component', {}, card)"><i class="far fa-file-import"></i>Import Component</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <application-tile :application="application" :card="card"/>

                <subheader-list-item title="Details" icon="fa-align-left"/>
                <container-list-item>
                    <data-row title="Certificate" v-if="application.cert">{{ application.cert.title }}</data-row>
                    <data-row title="Organization">{{ application.organization.title }}</data-row>
                    <data-row title="Description">{{ application.description }}</data-row>
                </container-list-item>

                <separator-list-item/>

                <navigation-list-item
                        @click="$openCard('application-applicants', {applicationId: application.id}, card)"
                        title="Applicants" icon="fa-users"
                        :active="(child && child.definition.component === 'application-applicants' && application.id === parseInt(child.props.applicationId))"
                />

                <separator-list-item/>

                <navigation-list-item
                    title="Conferences" icon="fa-presentation"
                />
                <navigation-list-item
                    title="Courses" icon="fa-chalkboard-teacher"
                />

                <template v-if="application.id">

                    <subheader-list-item title="Application Process" icon="fa-list-alt"/>

                    <draggable v-model="application.outline" handle=".drag-handle" @end="completeDrag" draggable=".t-card-list-item">
                        <transition-group>

                            <card-list-item class="t-card-list-item" v-for="o in application.outline" :key="o.id" @click="$openCard('new-component-editor', {componentId: o.component_id, outlineId: o.id}, card)">
                                <template #icon><i class="fa-fw fas fa-cube"></i></template>
                                <template #content>
                                    <div class="columns">
                                        <div class="column is-10">
                                            <div class="has-text-weight-bold">{{ o.title }}</div>
                                            <!--                                    <div class="meta has-text-grey-light">{{ o.component_title }}</div>-->
                                            <div class="meta has-text-grey-light">{{ o.type }}</div>
                                        </div>
                                        <div class="column has-text-right">
                                            <p class="control">
                                                <i class="fas fa-sort drag-handle"></i>
                                            </p>
                                        </div>
                                    </div>
                                </template>
                                <template #details v-if="o.type === 'SECTION'">
                                    <!--                            <draggable v-model="o.components" handle=".drag-handle" @end="completeDrag" draggable=".component">-->
                                    <!--                                <transition-group>-->
                                    <!--                                    <div class="component" :key="c.id" v-for="c in o.components" ><i class="fas fa-sort drag-handle mr-4"></i>{{c.title}}</div>-->
                                    <!--                                </transition-group>-->
                                    <!--                            </draggable>-->
                                </template>
                            </card-list-item>
                        </transition-group>
                    </draggable>

                </template>

            </card-list>

        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "@/TIER/components/DataRow";

    import {client as http} from "@/http_client";
    import moment from "moment";
    import ApplicationTile from "../../components/tiles/ApplicationTile.vue";
    import draggable from "vuedraggable";
    import CardListItem from "../../TIER/components/CardListItem.vue";

    export default {
        props: ['card', 'child', 'props'],
        components: {CardListItem, ApplicationTile, ContainerListItem, SeparatorListItem, DataRow, CardHeader, CardToolbar, CardBody, SearchListItem, NavigationListItem, SubheaderListItem, CardList, draggable},
        data() {
            return {
                application: {
                    type: '',
                    cert: {},
                    organization: {}
                }
            };
        },
        methods: {
            loadApplication: function(force) {
                this.$emit('loading', true);
                http.get('applications/' + this.props.applicationId, {force}).then(response => { // TODO: temporary endpoint
                    if (!response.data.outline) response.data.outline = [];
                    this.application = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },

            addOutline() {
                http.post('applications/outline/', {
                    type: 'SECTION',
                    application_id: this.application.id,
                    type_id: (this.sectionSelect) ? this.sectionSelect.id : null,
                    sort: this.application.outline.length + 1,
                    title: this.title
                }, {force: true}).then(response => {
                    this.application.outline.push(response.data);
                    this.type = null;
                    this.title = '';
                    this.sectionSelect = null;
                }, err => {
                    console.log(err);
                });
            },
            addRequiredComponent(type, component) {
                http.post('applications/component/', {
                    type: type,
                    entity_id: this.application.id,
                    component_id: component.id
                }, {force: true}).then(response => {
                    if (type === 'pre') {
                        this.preComponentSelect = null;
                    } else {
                        this.postComponentSelect = null;
                    }
                }, err => {
                    console.log(err);
                });
            },
            completeDrag: function() {
                http.post('applications/outline/order', this.application.outline.map(i => i.id)).then(response => {

                });
            },
            reload: function() {
                this.loadApplication(true);
            },
        },
        computed: {

        },
        watch: {
            'props.applicationId': function() {
                this.loadApplication();
            }
        },
        mounted: function() {
            this.loadApplication();
        }
    };
</script>

